// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-calendar .p-datepicker {
    font-size: 0.75rem !important;
    width: 220px !important;
    padding: 0.5rem !important;
    height: 18px !important;


}

.small-calendar .p-timepicker {
    font-size: 0.85rem !important;
}

.small-calendar .p-datepicker-calendar td {
    font-size: 0.7rem !important;
    padding: 0.25rem !important;
    height: 18px !important;


}

.small-calendar .p-datepicker-header {
    font-size: 0.85rem !important;
    padding: 0.25rem 0.5rem !important;
    height: 18px !important;

}

.p-datatable table {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px
}

.p-datatable table th,
.p-datatable table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.p-datatable thead th {
    background-color: #f4f4f4;
    border-bottom: 2px solid #ccc;
}
.my-create-button{
    background-color: #2D6DF6 !important;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/admin.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;;;AAG3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;;;AAG3B;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,uBAAuB;;AAE3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,oCAAoC;IACpC,YAAY;AAChB","sourcesContent":[".small-calendar .p-datepicker {\n    font-size: 0.75rem !important;\n    width: 220px !important;\n    padding: 0.5rem !important;\n    height: 18px !important;\n\n\n}\n\n.small-calendar .p-timepicker {\n    font-size: 0.85rem !important;\n}\n\n.small-calendar .p-datepicker-calendar td {\n    font-size: 0.7rem !important;\n    padding: 0.25rem !important;\n    height: 18px !important;\n\n\n}\n\n.small-calendar .p-datepicker-header {\n    font-size: 0.85rem !important;\n    padding: 0.25rem 0.5rem !important;\n    height: 18px !important;\n\n}\n\n.p-datatable table {\n    border-collapse: collapse;\n    width: 100%;\n    font-size: 14px\n}\n\n.p-datatable table th,\n.p-datatable table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n.p-datatable thead th {\n    background-color: #f4f4f4;\n    border-bottom: 2px solid #ccc;\n}\n.my-create-button{\n    background-color: #2D6DF6 !important;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
